import React, { FC } from 'react';

import { useProjectTermDictionary }                                                 from '../../../hooks';
import { MilestoneDateIcon, milestoneDateIconDefaultProps, MilestoneDateIconProps } from './MilestoneDateIcon';

const customStartDateIconDefaultProps: MilestoneDateIconProps = {
	...milestoneDateIconDefaultProps,
}

const CustomStartDateIcon: FC<Omit<MilestoneDateIconProps, 'label' | 'desc'>> = ( props ) => {
	
	let { getTerm } = useProjectTermDictionary();
	
	return (
		
		<MilestoneDateIcon
			{ ...props }
			label={ getTerm( 'PROJECT_DETAILS.CUSTOM_START_DATE.LABEL' ) }
			desc={ getTerm( 'PROJECT_DETAILS.CUSTOM_START_DATE.DESCRIPTION' ) }
			icon={ {
				...( props.icon ?? {} ),
				color: 'violet'
			} }
		/>
	);
};

CustomStartDateIcon.defaultProps = customStartDateIconDefaultProps;

export { CustomStartDateIcon }
